// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/" + chunkId + "." + {"2008":"77a6a17d","2389":"47257454","6135":"77a6a17d"}[chunkId] + ".css";
};